var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 785.68 611.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-dasharray:0 0 6.14 6.14;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{fill:none;}.cls-1,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke:#020202;}.cls-1,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-9{stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-width:1.17px;}.cls-2,.cls-8{stroke:#218cff;stroke-miterlimit:10;}.cls-10{fill:#ece70d;}.cls-11{fill:#d4d00c;}.cls-3{stroke-dasharray:0 0 6.07 6.07;}.cls-5{stroke-dasharray:0 0 6.09 6.09;}.cls-6{stroke-dasharray:0 0 5.99 5.99;}.cls-7{stroke-dasharray:0 0 5.91 5.91;}.cls-8{stroke-width:4.25px;}.cls-9{fill:#fff;stroke:rgba(2,2,2,.25);stroke-width:2px;}.cls-12{fill:#b8d9ff;}.cls-13{opacity:.25;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "566.17 36.22 534.02 36.22 534.02 13.76 566.17 13.76 558.12 24.99 566.17 36.22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 517.95,
    y: 7.02,
    width: 32.15,
    height: 22.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 517.95,
    y1: 119.17,
    x2: 517.95
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M777.93,365.5c-.3,3.13,1.37,6.45-.5,9.56-5.04,8.41-16.89,13.42-24.67,18.03-5.6,3.32-9.21,5.81-14.24,8.62-20.71,11.56-42.95,17.23-64.88,6.73-6.32-3.03-9.83-4.18-16.5-4.59-1.45-2.76-3.14-5.54-4.8-8.22-3.21-5.2-7.22-9.51-9.71-15.16-5.69-12.95-7.34-25.54-14.81-38.35-5.01-8.59-10.41-19.46-9.23-30.27-13.79-8.1-27.49-15.63-38.85-27.03-5.02-5.04-10.75-12.05-13.99-17.94-5.55-10.09-2.47-19.01-2.4-29.55,.07-10.54-.38-20.88-2.89-31.06-2-8.11-3.07-15.25-3.21-23.67-.06-3.65,.65-7.96-1.76-11.28-2.77-3.81-7.12-3.56-10.84-6.95-4.21-3.84-9.35-11.73-11.17-16.95-2.14-6.14,.21-10.25-3.46-15.51-3.06-4.38-8.75-7.43-12.75-11.17-.44-.41-.92-.78-1.43-1.17,3.01-.47,4.45-.56,7.81-.16,8.53,1.02,17.59,2.68,23.55,9.63,3.95,4.6,4.26,10.26,9.16,14.09,8.77,6.86,21.09,3.9,30.68,7.08,13.33,4.42,14.96,15.06,20.67,25.9,8.71,16.52,13.82,34.29,23.52,49.95,5.77,9.32,7.76,16.96,11.84,27.5,4.08,10.54,9.67,22.79,18.44,31.23,3.13,3.01,10.54,4.51,13.9,6.29,13.48,7.13,25.25,11.28,35.27,23.06,6.96,8.18,11.41,20.46,22.6,24.56,6.36,2.33,14.22-.57,20.57,.36,10.81,1.59,18.91,7.44,28.67,11.51-.18,.15-.3,.23-.43,.39-3.47,4.36-3.65,9.14-4.17,14.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.29,557.24c12.27,7.02,34.24,1.81,48.01,1.81,15.58,0,29.2-.96,44.66-4.33,16.4-3.57,36.29-2.42,45.87-17.48,4.3-6.76,9.08-17.69,16.29-21.95,4-2.36,10.3-2.28,14.62-4.2,11.1-4.94,11.57-13.76,19.82-21.1,7.16-6.37,19.76-9.73,28.5-13.49,3.56-1.53,6.11-3.46,9.91-4.55,2.51-.72,2.68,2.87,5.74,1.83,9.28-3.15,17.71-14.99,22.86-22.92,2.76-4.25,3.81-9.91,6.77-13.82,5.71-7.53,14.94-10.94,17.6-20.95,3.91-14.68-6.43-31.28,11.67-37.96,7.09-2.62,9.05,.61,12.67-7.54,2.57-5.79,1.15-15.16,5.96-20.11,7.22-7.44,18.64-4.6,22.38-15.14,2.54-7.16-.53-16.37,.81-23.76,1.09-6.02,5.06-11.67,8-16.96,3.36-6.04,4.97-16.46,9.26-21.78,4.53-5.62,15.7-7.67,22.09-11.48,15.23-9.08,23.91-23.13,37.59-32.82,9.53-6.75,22.87-5.62,32.68-10.12,12.78-5.87,28.12-23.02,37.02-33.41,12.46-14.57,19.48-31.72,26.15-49.45,4.48-11.92,2.55-17.64,16.29-16.16,8.58,.93,18.18,2.34,23.86,9.65,3.75,4.83,3.71,9.9,8.89,14.17,9.25,7.64,20.68,3.76,31.07,6.82,14.43,4.26,14.55,15.67,20.48,26.14,9.05,15.98,13.17,34.9,23.48,49.98,6.14,8.97,7.91,17.22,11.65,27.17,3.79,10.08,10.24,24.11,18.47,31.52,2.94,2.65,11.12,4.7,14.25,6.34,12.54,6.58,25.97,11.13,35.07,22.73,6.32,8.05,12.04,21.67,22.49,24.97,5.93,1.87,14.63-.53,20.77,.1,11.48,1.18,20.29,9.05,31.53,12.68"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.25,605.54c.97-.18,1.95-.36,2.95-.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M179.09,603.94c41.91-7.44,103.33-16.61,139.22-20.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M321.3,583.21c1.02-.1,2.01-.2,2.98-.3,.46-.9,.97-1.76,1.53-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M329.84,575.79c10.85-9.71,30.16-11.87,44.27-13.85,22.87-3.19,47.38-9.83,66.96-21.59,14.35-8.62,29.23-10.8,45.38-12.14,11.58-.96,26.05-1.4,36.44-6.25,10.36-4.82,16.08-18.46,25.83-24.24,10.72-6.36,25.48-5.87,37.55-9.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M589.17,487.35c.95-.35,1.87-.73,2.77-1.15-.06-1.07-.38-2-.9-2.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M586.21,479.71c-3.85-1.71-8.72-2.5-11.52-3.46-13.77-4.69-26.86-14.01-40.24-17.77-18.47-5.18-42.68-3.57-62.04-2.15-8.57,.63-18.05,3.81-25.18-1.47-5.53-4.1-5.69-10.8-11.09-14.92-6.32-4.83-17.41-6.79-24.96-8.7-12.28-3.1-18.4-3.79-22.52-14.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M387.64,414.1c-.28-.9-.56-1.86-.82-2.89,.96-.28,1.93-.52,2.91-.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M395.55,409.53c9.71-1.2,19.85-.9,29.42-5.3,19.7-9.04,34.08-31.11,55.2-36.29,8.93-2.19,19.16,.69,28.16-.81,9.84-1.64,31.64-6.72,39.79-12.76,13.41-9.95-.76-19.6-10.81-24.55-18.07-8.89-35.38-18.56-53.25-27.84-9.43-4.9-19.62-7.3-29.21-11.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M452.12,289.7c-.92-.4-1.82-.82-2.72-1.26-.21-.83-.3-1.88-.29-2.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M449.24,283.07c.12-1.11,.31-2.15,.56-2.94,1.01-.13,2-.28,2.97-.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M458.71,278.46c22.83-5.57,37.36-19.73,53.34-36.94,3.58-3.86,15.01-9.82,15.45-15.05,.36-4.25-6.81-11.03-10.24-13.4-6.6-4.58-22.84-8.12-19.62-11.9s38.19-23.22,31.25-28.98c-6.18-5.14-8.04-22.96-11.16-39.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M517.15,129.98c-.2-.99-.41-1.96-.63-2.93"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 170.25,
    cy: 605.54,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 324.28,
    cy: 582.91,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 591.93,
    cy: 486.2,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 386.81,
    cy: 411.21,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 553.42,
    cy: 346.67,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 450.4,
    cy: 284.41,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 525.92,
    cy: 224.88,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 497.85,
    cy: 202.24,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 529.09,
    cy: 172.35,
    r: 5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummit);
export default __webpack_public_path__ + "static/media/summit.acf6ffbf9d83199854b5018308ec853b.svg";
export { ForwardRef as ReactComponent };